// import { CheckCircledIcon, MinusCircledIcon } from '@radix-ui/vue-icons's
import {sendStatus} from "@/i18n/i18nEnum.tsx";

const toastMessage = (pageName: string) => {
    return {
        DeleteSuccess: {
            Msg: `Xóa ${pageName} thành công!`,
            Type: 'success'
        },
        DeleteWarning: {
            Msg: `Không có ${pageName} nào được chọn!`,
            Type: 'warning'
        },
        DeleteError: {
            Msg: `Xóa ${pageName} thất bại!`,
            Type: 'error'
        },
        AddNewSuccess: {
            Msg: `Thêm ${pageName} thành công!`,
            Type: 'success'
        },
        EditSuccess: {
            Msg: `Sửa ${pageName} thành công!`,
            Type: 'success'
        },
        EditWarning: {
            Msg: `Không có ${pageName} nào được chọn!`,
            Type: 'warning'
        }
    }
}

const actionsType = (pageName?: string) => {
    return {
        AddNew: {
            Title: `Thêm ${pageName}`,
            Type: 'addNew'
        },
        Edit: {
            Title: `Sửa ${pageName}`,
            Type: 'edit'
        },
        Delete: {
            Title: `Xóa ${pageName}`,
            Type: 'delete'
        },
        DeleteMultiple: {
            Title: `Xóa nhiều ${pageName}`,
            Type: 'delete-multiple'
        },
        Default: {
            Title: 'Không có hành động nào được thực hiện',
            Type: 'default'
        }
    }
}

const toastConfirmMsg = (pageName: string, id?: string) => {
    return {
        Delete: {
            Title: 'Xác nhận xóa',
            Msg: `Bạn có chắc chắn muốn xóa <b>${pageName}</b>${id ? ' với Mã: <b>' + id + '</b>' : ''}?`
        },
        DeleteMultiple: {
            Title: 'Xác nhận xóa nhiều',
            Msg: `Bạn có chắc chắn muốn xóa tất cả <b>${pageName}</b> đang chọn?`
        }
    }
}

const pageSizes = [10, 25, 50, 100]

export const status = {
    Active: {
        Title: 'Hoạt động',
        Value: 1
    },
    Deactivate: {
        Title: 'Ngưng Hoạt động',
        Value: 0
    }
}

export const gender = {
    Male: {
        Name: 'Nam',
        Value: 0
    },
    Female: {
        Name: 'Nữ',
        Value: 1
    },
    Other: {
        Name: 'Khác',
        Value: 2
    }
}

// export const statuses = [
//   {
//     label: status.Active.Title,
//     value: status.Active.Value,
//     icon: h(CheckCircledIcon),
//     class: 'text-[#50B83C]'
//   },
//   {
//     label: status.Deactivate.Title,
//     value: status.Deactivate.Value,
//     icon: h(MinusCircledIcon),
//     class: 'text-red-500'
//   }
// ]

export const genders = [
    {
        label: gender.Male.Name,
        value: gender.Male.Value
    },
    {
        label: gender.Female.Name,
        value: gender.Female.Value
    },
    {
        label: gender.Other.Name,
        value: gender.Other.Value
    }
]

export const actionsFooter = {
    Help: {
        Name: 'Giúp',
        Icon: 'icon-help'
    },
    Add: {
        Name: 'Lưu',
        Icon: 'icon-add'
    },
    AddAndRenew: {
        Name: 'Lưu và Thêm',
        Icon: 'icon-add-renew'
    },
    Cancel: {
        Name: 'Hủy bỏ',
        Icon: 'icon-cancel'
    }
}

export const FeePayer = {
    Shop: 1,
    Buyer: 2
}

export const errorMsg = {
    Error: "Lỗi hệ thống! Vui lòng liên hệ hotline: 1900 5028 để được hỗ trợ!"
}

export const i18nMinigame = {
    Spin: {
        Name: "Vòng xoay",
        Code: "VONGQUAY"
    },
    Puzzle: {
        Name: "Mảnh ghép",
        Code: "MANHGHEP"
    },
}

export const awardSent = [
    {
        Title: "Đã xác nhận",
        Status: sendStatus.Confirm,
        Color: 'text-orange-500'
    },
    {
        Title: "Hoàn tất",
        Status: sendStatus.Sent,
        Color: 'text-green-500'
    },
    {
        Title: "Đang vận chuyển",
        Status: sendStatus.OnDelivery,
        Color: 'text-blue-500'
    }
]

export {toastMessage, actionsType, toastConfirmMsg, pageSizes}
